
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","fill":"#036","d":"M31 12.998v-11h5V-.001H0v1.999h5v10.999c0 5.252 7.264 9.239 11 11.002-3.736 1.763-11 5.75-11 11.002v10.998H0v2h36v-2h-5V35.001c0-5.252-7.265-9.239-11-11.002 3.735-1.763 11-5.748 11-11.001zm-2 22.003v10.998H7V35.001c0-4.388 7.518-8.56 11-10.002 3.481 1.442 11 5.614 11 10.002zM18 22.999c-3.482-1.443-11-5.615-11-10.002V1.998h22v10.999c0 4.388-7.52 8.56-11 10.002z"}})])
          )
        }
      }
    